import React from 'react';
import {Link} from 'react-router';

import {NoDataMsg, Button} from '@albert-io/atomic';

const CreateAssignmentNoDataMsg = () => {
  const hasPreviousHistoryEntry = (global.history?.length || 0) > 1;
  const backButton = hasPreviousHistoryEntry ? (
    <Button
      className='u-mar-t_5'
      onClick={() => global.history.back()}
      label='Back to folders list'
    >
      Back
    </Button>
  ) : (
    <Button className='u-mar-t_5' as={Link} label='Back to folders list' to='/saved'>
      View folders
    </Button>
  );
  return (
    <NoDataMsg.Container className='u-mar-t_7 u-pad_4' centered>
      <NoDataMsg.Heading>Something went wrong</NoDataMsg.Heading>
      <NoDataMsg.Body>An error occurred while creating your assignment</NoDataMsg.Body>
      {backButton}
    </NoDataMsg.Container>
  );
};

export default CreateAssignmentNoDataMsg;
